module.exports = __webpack_public_path__ + "img/sanjuan.568a73a3.png";